export default __webpack_public_path__ + "static/media/12.daa04094.PNG";